export default {
      id: "status_lose-usage",
      viewBox: "0 0 14 14",
      url: "/" + "images/icons.3.109.2.svg#status_lose-usage",
      toString: function () {
        return this.url;
      }
    }